<div mat-dialog-content>
  <div class="full-width text-right" *ngIf="buttonType === 2">
    <button type="button" class="btn btn-sm btn-default" title="{{'BUTTON.CANCEL' | translate}}"
      (click)="dialogRef.close(false)">
      <i class="fa fa-times m-0"></i>
    </button>
  </div>
  <div class="text-center">
    <img class="img-responsive image-center" style="max-width: 200px;"
      [src]="imagePath ? imagePath : ProductMediaID ? serverUrl + 'Product/GetImage?id=' + ProductMediaID + '&productID=' + ProductID + '&width=200&height=200' : './assets/img/no-image.png'"
      [alt]="ProductName" />
  </div>
  <div *ngIf="message"><br>{{message}}</div>
</div>